// i18n.js
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import { CMSPath } from '../config/Constant';
import {GetTranslationKeys} from './configTranslationKeys';
import { setSupportedLanguages, setTranslationResources } from '../Redux/Reducers/translationReducer';
const common_en = require('./en/en_translations.json');

export const updateAdditionalTranslationResources = () => {
return async (dispatch, getState) => {

  const { isOnline } = getState().appConfigSlice;
  const { persistTranslationResources } = getState().translationSlice;
  
  let translationResources;
  
  if (isOnline) {
    translationResources = await dispatch(getLanguage());
  } else {
    translationResources = persistTranslationResources;
  }

  Object.keys(translationResources).forEach(language => {
    const resourceBundle = translationResources[language];
    i18n.addResourceBundle(
      language,
      'translations',
      resourceBundle.translations,
      false,
      true,
    );
  });
}};

const getLanguage = () => {
return async (dispatch) => {

  let language = {
    en: {
      translations: common_en,
    },
  };
  try {

    const headerConfig = {};

    const langResponse = await fetch(
      `${CMSPath}/Connector/rest/assets?type=localisation`,
      headerConfig,
    );

    if (langResponse.ok) {
      const data = await langResponse.json();
      console.log('Successfully fetched translation languages', data);

      let resourcesLng = {};

      for (let i = 0; i < data.payload.length; i++) {
        const newLang = data.payload[i].languageCode;
        resourcesLng[newLang] = {
          translations: await GetTranslationKeys(newLang),
        };
      }

      dispatch(setTranslationResources(resourcesLng));
      return resourcesLng;
    } else {
      console.log('Error while fetching translation languages');
      return language;
    }
  } catch (error) {
    console.log('Error while getting translation keys');
    console.log(error);
    return language;
  }
}}

function i18nextInit() {
  
  i18n.use(initReactI18next).init({
    interpolation: {escapeValue: false},
    lng: 'en', // Initial language
    fallbackLng: 'en',
    defaultNS: 'translations', // Set default namespace
    resources: {
      en: {
        translations: common_en,
      },
    },
  });
}

export default i18nextInit;
